import { Player } from "@lottiefiles/react-lottie-player";
import { useState } from "react";
import styled from "styled-components";
import Successfully from "../../assets/Successfully-Done.json";
import { getCardConfig } from "../../components/common/cardRules";
import { FormatDecimal } from "../../library/core/formats";
import FixedBottomButton from "../form/FixedBottomButton";

import { VoucherTypes } from "../../library/core/enums";
import { SecondaryButton } from "../form/secondary-button";
const Card = styled.div`
  background: #111220; /* dark panel */
  border: 1px solid #34353f; /* subtle outline */
  border-radius: 16px;
  padding: 20px;
  max-width: 720px;
  margin: 1rem auto 2rem;
`;
const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;
const Hr = styled.hr`
  border: 0;
  height: 2px;
  background: #34353f;
  margin: 16px 0;
`;

export const RedemptionSuccessMessage = ({
  showMessage,
  totalBillAmount,
  redeemedAmount,
  totalRedeemed,
  digits,
  dataModel,
  currencyPrefix = "$",
  newTrxButton,
  onUseAnotherVoucher,
}) => {
  const [showAnimation, setShowAnimation] = useState(true);
  const [showKaching, setShowKaching] = useState(false);

  if (!showMessage || totalBillAmount <= 0) return null;

  digits ||= 2;
  const applied = Math.min(
    Number(redeemedAmount ?? redeemedAmount ?? 0),
    Number(totalBillAmount ?? 0)
  );
  const remaining =
    totalBillAmount > (totalRedeemed ?? 0)
      ? totalBillAmount - (totalRedeemed ?? 0)
      : 0;

  const voucherNum = dataModel?.voucher?.VoucherNumber ?? "";
  const { bgClass, prefixCard, textColor, logoSrc } = getCardConfig(voucherNum);
  const last4 = voucherNum.slice(-4) || "****";
  const certificateLabel = `${prefixCard}${last4}`;

  const voucherBalance = (dataModel.voucher && dataModel.voucher.VoucherKind) ===
    VoucherTypes.GiftCard ? Number(dataModel?.voucher?.Balance - applied) : 0;

  return (
    <>
      {showAnimation && (
        <Player
          src={Successfully}
          className=""
          autoplay
          onEvent={(event) => {
            if (event === "complete") {
              setShowAnimation(false);
              setTimeout(() => setShowKaching(true), 100); // slight delay for effect
            }
          }}
        />
      )}
      <div className="flex flex-col items-center md:max-w-[500px] mx-auto mt-[10vh]">
        <h1
          className={`text-center font-headings-primary font-medium text-[28px] leading-[33.6px] mb-2 mt-6 transition-all duration-700 ease-out ${showKaching
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-10"
            }`}
        >
          Ka-ching!
        </h1>
      </div>
      <div
        className={`transition-all duration-700 md:max-w-[500px] mx-auto ease-out ${showKaching ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
      >
        <div>
          <p className="text-center mb-4 text-[16px] font-body-primary text-white">
            {currencyPrefix}
            {FormatDecimal(applied, digits)} redeemed successfully
          </p>
        </div>

        <Card>
          <Row>
            <span className="text-base leading-6 font-body-primary text-white">
              Total bill
            </span>
            <span className="text-base leading-6 font-body-primary text-white">
              {currencyPrefix}
              {FormatDecimal(totalBillAmount, digits)}
            </span>
          </Row>

          <Hr />

          <div>
            <Row>
              <span className="text-base leading-6 font-body-primary text-white">
                {certificateLabel}
              </span>
              <span className="text-base leading-6 font-body-primary text-white">
                -{currencyPrefix}
                {FormatDecimal(applied, digits)}
              </span>
            </Row>
            <div className="mt-2 text-base font-body-primary text-[#bcbec7]">
              Balance: {currencyPrefix}
              {FormatDecimal(voucherBalance, digits)}
            </div>
          </div>

          <Hr />

          <Row>
            <span
              className={`text-base leading-6 font-body-primary ${remaining > 0 ? "text-chilli" : "text-green-500"
                }`}
            >
              Bill remaining
            </span>
            <span
              className={`text-base leading-6 font-body-primary ${remaining > 0 ? "text-chilli" : "text-green-500"
                }`}
            >
              {currencyPrefix}
              {FormatDecimal(remaining, digits)}
            </span>
          </Row>
        </Card>

        {remaining > 0 && (
          <div>
            <p className="text-center mb-4 text-[16px] font-body-primary text-white z-[100]">
              Use another certificate, gift card, or payment method for the remaining balance.
            </p>
          </div>
        )}
      </div>
      <div

      >
        <FixedBottomButton className={`transition-all duration-700 md:max-w-[500px] mx-auto ease-out ${showKaching ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}>
          {newTrxButton && <div className="mt-4">{newTrxButton}</div>}
          {remaining > 0 && (
            <SecondaryButton
              onClick={onUseAnotherVoucher}
              className="mx-auto mt-4"
            >
              Redeem another card/certificate
            </SecondaryButton>
          )}
        </FixedBottomButton>
      </div>
    </>
  );
};
